import { Image } from 'antd'
import { FileAttachment } from '../../Contracts'

interface PhotoMessageProps {
  file: FileAttachment
}

const PhotoMessage = ({ file }: PhotoMessageProps) => {
  return (
    <Image
      src={file.url}
      style={{ borderRadius: 8, maxWidth: '100%', display: 'block' }}
      placeholder
    />
  )
}

export default PhotoMessage
